import React, { useState } from "react"
import { Icon } from "semantic-ui-react"
import BifrostButton from "../../../../../../Components/BifrostElementComponent/BifrostButton/BifrostButton"
import BifrostModal from "../../../../../../Components/BifrostPageComponent/BifrostModal/BifrostModal"
import Loader from "../../../../../../Components/BifrostPageComponent/Loader/Loader"
import { usePostData } from "../../../../../../Hooks/FetchHooks/PostDataService/usePostData"
import { validateInput } from "../../../../../../Utils/Validator/ValidateInput"
import CreateOrganizationPage from "./CreateOrganizationPage"

const initialValueState = {
	name: "",
	package_id: null
}

const initialValidatedState = {
	name: true,
	package_id: true
}

const CreateOrganizationModal = ({ refreshOrgs }) => {
	const [values, setValues] = useState(initialValueState)
	const [validated, setValidated] = useState(initialValidatedState)
	const [showErrorMessage, setShowErrorMessage] = useState(false)
	const [openModal, setOpenModal] = useState(false)

	const { isLoading, postItem } = usePostData()

	const submitHandler = () => {
		validateInput(values, validated, setValidated) &&
			postItem("/api/v2/org", values, refreshOrgs)
				.then(() => {
					setValidated({ ...initialValidatedState })
					setValues({ ...initialValueState })
					setShowErrorMessage(false)
					setOpenModal(false)
				})
				.catch(() => {
					setValidated({ ...initialValidatedState })
					setValues({ ...initialValueState })
					setShowErrorMessage(true)
				})
	}

	const cancelHandler = () => {
		setValidated({ ...initialValidatedState })
		setValues({ ...initialValueState })
		setShowErrorMessage(false)
		setOpenModal(false)
	}

	return (
		<BifrostModal
			title={"Create Organization"}
			open={openModal}
			setOpen={setOpenModal}
			closeOnEscape={!isLoading}
			closeOnDimmerClick={!isLoading}
			trigger={
				<BifrostButton>
					<Icon name="suitcase" />
					Create
				</BifrostButton>
			}
			modalPage={
				isLoading ? (
					<Loader backgroundColor="white" inverted height="1px" minHeight="100px" />
				) : (
					<CreateOrganizationPage validated={validated} values={values} setValues={setValues} showErrorMessage={showErrorMessage} />
				)
			}
			modalActions={
				<>
					<BifrostButton style={{ display: "inline-block" }} onClick={() => submitHandler()} disabled={isLoading}>
						Submit
					</BifrostButton>
					<BifrostButton onClick={() => cancelHandler()} style={{ display: "inline-block" }} color="gray" disabled={isLoading}>
						Cancel
					</BifrostButton>
				</>
			}
		/>
	)
}

export default CreateOrganizationModal
